import { render } from "./B2bPageEstadisticasRecibidas.vue?vue&type=template&id=4edda2f2&scoped=true&lang=pug"
import script from "./B2bPageEstadisticasRecibidas.vue?vue&type=script&lang=js"
export * from "./B2bPageEstadisticasRecibidas.vue?vue&type=script&lang=js"

import "./B2bPageEstadisticasRecibidas.vue?vue&type=style&index=0&id=4edda2f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edda2f2"]])

export default __exports__